import { useTranslation } from 'react-i18next';
import FormatTime from 'components/FormatTime';
import {
  Bpm,
  Duration,
  Energy,
  Genre,
  UserLoop,
} from 'services/store/remixer/types';
import { StyledRemixerTag, StyledSecondaryTag } from './styled';

export const BPMTag = ({ value }: { value: Bpm['value'] }) => {
  const { t } = useTranslation();
  return (
    <StyledRemixerTag
      label={`${value} ${t('aiMusicGenerator:tagLabels:bpm')}`}
    />
  );
};

export const DurationTag = ({ value }: { value: Duration['value'] }) => (
  <StyledRemixerTag label={<FormatTime time={value} />} />
);

export const EnergyTag = ({ value }: { value: Energy['value'] }) => {
  const { t } = useTranslation();

  if (!value) return null;

  return (
    <StyledRemixerTag
      label={`${t(`aiMusicGenerator:energy:${value}`)} ${t(
        'aiMusicGenerator:tagLabels:energy'
      )}`}
    />
  );
};

export const GenreTag = ({ value }: { value: Genre['value'] }) => (
  <StyledRemixerTag label={value} />
);

export const UserLoopTag = ({ value }: { value: UserLoop['value'] }) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledRemixerTag label={value.loopFileName} />
      <StyledRemixerTag
        label={`${t('aiMusicGenerator:userLoopSelector:entropy')} ${
          value.entropy * 100
        }`}
      />
    </>
  );
};

export const RemoveUserLoopTag = () => {
  const { t } = useTranslation();

  return <StyledSecondaryTag label={t('remixer:userLoop:clipRemoved')} />;
};
